import "../Styles/Legal.css";
import Footer from "./Footer";
import Header from "./Header";

function CookiePolicy() {
  return (
    <>
    <Header/>
    <div className="legal">
      <div className="legal-container">
        <h1>Cookie Policy</h1>

        <p className="date">Effective Date: 25 June 2026</p>

        <p>
          Cluster Clear uses cookies and similar technologies to improve your
          browsing experience, understand website usage and support platform
          functionality.
        </p>

        <h2>What Are Cookies?</h2>

        <p>
          Cookies are small text files stored on your device when you visit a
          website. They help websites remember information and function more
          effectively.
        </p>

        <h2>How We Use Cookies</h2>

        <p>
          We may use cookies to keep users signed in, remember preferences,
          improve website performance, understand visitor activity and detect
          security issues.
        </p>

        <h2>Analytics Cookies</h2>

        <p>
          Analytics cookies help us understand pages visited, device type,
          browser type, referral source and general usage patterns. This helps
          us improve Cluster Clear.
        </p>

        <h2>Managing Cookies</h2>

        <p>
          Most browsers allow you to control or disable cookies through browser
          settings. Disabling cookies may affect some features of the website.
        </p>

        <h2>Changes to This Policy</h2>

        <p>
          We may update this Cookie Policy from time to time to reflect changes
          in our service or legal requirements.
        </p>

        <h2>Contact</h2>

        <p>support@clusterclear.app</p>
      </div>
    </div>
    <Footer/>
      </>
  );
}

export default CookiePolicy;